import React from 'react';
import {
    defineBlock,
    smartProps,
    useEditor,
    EditableDiv,
    EditableImg,
    ChildrenBlock,
    useSmartProp,
    useInspectorControl,
} from '@smartfire/gutenberg-react';
import style from './block.module.scss';
import { InnerBlocks } from '@wordpress/block-editor';
import Hot from './hot.svg';
import Cold from './cold.svg';
import { ReactComponent as Arrow } from './arrow.svg';
import { ReactComponent as Download } from './download.svg';
import { PanelBody, PanelRow, ToggleControl } from '@wordpress/components';

function Inspector() {
    const [showTemp, setShowTemp] = useSmartProp('showTemp');

    return (
        <>
            <PanelBody title="Paramètres" initialOpen={true}>
                <PanelRow>
                    <ToggleControl
                        label={"Montrer l'encadré température"}
                        checked={showTemp}
                        onChange={() => {
                            setShowTemp(!showTemp);
                        }}
                    />
                </PanelRow>
            </PanelBody>
        </>
    );
}

function Block({ showTemp }) {
    const { isEditing } = useEditor();
    useInspectorControl(Inspector);

    const showPopupDevis = () => {
        let event = new CustomEvent('toggle-popup-devis');
        document.dispatchEvent(event);
    };

    return (
        <div className={!isEditing && 'content-container'}>
            <div className={style.block}>
                <div className={style.colLeft}>
                    <EditableDiv className={style.title} smartProp="title" />
                    {isEditing ? (
                        <InnerBlocks
                            allowedBlocks={[
                                'smartfire/froid-product-description-spec-item',
                            ]}
                            templateLock={false}
                        />
                    ) : (
                        <div className={style.specs}>
                            <ChildrenBlock />
                        </div>
                    )}
                    <EditableDiv
                        className={style.text}
                        smartProp="description"
                        allowedFormats={['core/bold']}
                    />
                    <div className={style.listContainer}>
                        <div className={style.col}>
                            <EditableDiv
                                className={style.subtitle}
                                smartProp="colLeftTitle"
                            />
                            <EditableDiv
                                className={style.list}
                                tagName="ul"
                                multiline="li"
                                smartProp="colLeftList"
                                placeholder={'Entrez un texte'}
                            />
                        </div>
                        <div className={style.col}>
                            <EditableDiv
                                className={style.subtitle}
                                smartProp="colRightTitle"
                            />
                            <EditableDiv
                                className={style.list}
                                tagName="ul"
                                multiline="li"
                                smartProp="colRightList"
                                placeholder={'Entrez un texte'}
                            />
                        </div>
                    </div>
                </div>
                <div className={style.colRight}>
                    <EditableImg className={style.image} smartProp="image" />

                    {showTemp && (
                        <div className={style.tempContainer}>
                            <div className={style.icons}>
                                <img src={Hot} alt="chaud" />
                                <img src={Cold} alt="froid" />
                            </div>
                            <EditableDiv className={style.temp} smartProp="temperature" />
                        </div>
                    )}

                    <div className={style.actionButtons}>
                        <a
                            href={window.productPdf !== '' && window.productPdf}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <button className={style.button}>
                                <Download />
                                Télécharger la fiche produit
                            </button>
                        </a>
                        <button className={style.button} onClick={showPopupDevis}>
                            <Arrow />
                            Demande de devis
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default defineBlock({
    Block,
    smartProps: {
        image: smartProps.any.withDefault({}),
        title: smartProps.string.withDefault(''),
        description: smartProps.string.withDefault(''),
        colLeftTitle: smartProps.string.withDefault(''),
        colLeftList: smartProps.string.withDefault(''),
        colRightTitle: smartProps.string.withDefault(''),
        colRightList: smartProps.string.withDefault(''),
        temperature: smartProps.string.withDefault(''),
        showTemp: smartProps.bool.withDefault(true),
    },
    setup: {
        title: 'Froid - Description Produit',
    },
});
